import { render } from "./C4SubmitError.vue?vue&type=template&id=06245e30"
import script from "./C4SubmitError.vue?vue&type=script&lang=js"
export * from "./C4SubmitError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__